'use client';

import { useEffect, useState } from 'react';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';
import { cn } from '@/app_lib/utils/utils';

// biome-ignore lint/style/useNamingConvention: I'm keeping it
export const PaywallaxMarkII = () => {
  const { showPaywallax } = usePaywall();
  const [displayContainer, setDisplayContainer] = useState(false);

  useEffect(() => {
    if (showPaywallax) {
      setDisplayContainer(true);
    }
  }, [showPaywallax]);

  return (
    <div
      className={cn('paywallax-ii-selector', 'z-9999 m-auto w-full', {
        'fixed top-[100dvh] right-0 left-0 animate-slide-up': displayContainer,
        hidden: !displayContainer,
      })}
    />
  );
};
